import classnames from 'classnames';

import {A} from 'components/atoms/LinksAndButtons/A';
import {Button, ButtonColor, ButtonSize, ButtonType} from 'components/atoms/LinksAndButtons/Button';
import {P} from 'components/atoms/Text/P';
import {ReadMore} from 'components/atoms/LinksAndButtons/ReadMore';

import {SITE_URLS} from 'features/search/constants';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {getSiteSpecificConfig} from 'features/services/utils/env-helper';
import {getFormattedMessage} from 'features/services/utils/language-helper';

import './style.scss';
import {Headline} from '@atoms/Text/Headline';
import {HeadlineLevel, HeadlineFont } from 'features/ui/enums';

interface Props {
    objectId: string;
    objectVipKey: string;
    big?: boolean;
}

export const ClickToBuyBanner: React.FunctionComponent<Props> = ({objectId, objectVipKey, big}) => {
    const classes = classnames('click-to-buy-banner', 'no-styles', {
        'click-to-buy-banner--small': !big,
        'click-to-buy-banner--large': big,
    });

    let url: string;

    if(typeof objectVipKey === 'undefined') {
        url = `${SITE_URLS.clickToBuy}info/${objectId}/`;
    } else {
        url = `${SITE_URLS.clickToBuy}info/${objectId}/${objectVipKey}`;
    }

    return (
        <A 
            href={url} 
            className={classes} 
            route 
            title={getFormattedMessage('jm.components.ClickToBuyBanner.isBookable')} 
        >
            {big ?
                <React.Fragment>
                    <Headline level={HeadlineLevel.H2} darkBg>
                        <FormattedMessage id="jm.components.ClickToBuyBanner.isBookable" />!
                    </Headline>
                    <P className="dark-bg">
                        <FormattedMessage id="jm.components.ClickToBuyBanner.bookingDescription" values={{siteName: getSiteSpecificConfig().siteName}} />
                    </P>
                    <Button 
                        onClick={() => {}} 
                        buttonColor={ButtonColor.LIGHT} 
                        buttonSize={ButtonSize.DEFAULT} 
                        buttonType={ButtonType.DEFAULT} 
                    >
                        <FormattedMessage id="jm.components.ClickToBuyBanner.bookThis" />
                    </Button>
                </React.Fragment> :
                <React.Fragment>
                    <Headline level={HeadlineLevel.H4} font={HeadlineFont.SERIF} darkBg>
                        <FormattedMessage id="jm.components.ClickToBuyBanner.isBookable" />
                    </Headline>
                    <ReadMore
                        darkBg
                        text={getFormattedMessage('jm.components.ClickToBuyBanner.readMore')}
                    />
                </React.Fragment>
            }
        </A>
    )
};
